module.exports = __webpack_public_path__ + "img/help-success.f518d990.png";